import React, {Component} from "react";
import {ENVIRONMENTAL} from '../Constants';
import {Badge} from "reactstrap";

export default class Environmental  extends Component{

    constructor(props) {

        super(props);

        this.state = ENVIRONMENTAL;
    }


    componentDidMount(){
        let data = this.props.data;
        let keys = Object.keys(data);

        if(data){
            for (let key in keys){
                this.setState({[keys[key]]: data[keys[key]]});
            }
        }
    }

    onChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
        this.props.update(this.props.type,  this.props.position, event.target.name, event.target.value);
    };

    render(){

        const {
            rates,
            removeActivity,
            type,
            position
        } = this.props;


        const {
            severity,
            likelihood,
            location,
            aspect,
            impact,
            condition,
            control_influence,
            activity,
            current_controls
        } = this.state;

        return(
            <div className="template-holder" style={{backgroundColor: "#ccc",padding: "10px",borderRadius: "4px",marginBottom: "15px",position: "relative"}}>
                {
                    position !== 0?
                        <Badge
                            onClick={() => removeActivity(type, position)}
                            color="danger" style={{position: "absolute", right: "15px", cursor: "pointer"}}>X</Badge>: null
                }
                <div className="form-group">
                    <label
                        htmlFor="activity"
                        className="control-label required">
                        Activity
                    </label>
                    <input onChange={this.onChange} className="form-control required" type="text" name="activity" id="activity" value={activity}/>
                </div>
                <div className="form-group">
                    <label
                        htmlFor="location"
                        className="control-label required">
                        Location
                    </label>
                    <textarea onChange={this.onChange} className="form-control required" name="location" id="location" value={location}/>
                </div>
                <div className="form-group">
                    <label
                        htmlFor="aspect"
                        className="control-label required">
                        Aspect
                    </label>
                    <textarea onChange={this.onChange} className="form-control required" name="aspect" id="aspect" value={aspect}/>
                </div>

                <div className="form-group">
                    <label
                        htmlFor="impact"
                        className="control-label required">
                        Impact
                    </label>
                    <textarea onChange={this.onChange} className="form-control required" name="impact" id="impact" value={impact}/>
                </div>

                <div className="form-group">
                    <label
                        htmlFor="condition"
                        className="control-label required">
                        Condition
                    </label>
                    <textarea onChange={this.onChange} className="form-control required" name="condition" id="condition" value={condition}/>
                </div>

                <div className="form-group">
                    <label
                        htmlFor="control_influence"
                        className="control-label required">
                        Control / Influence
                    </label>
                    <textarea onChange={this.onChange} className="form-control required" name="control_influence" id="control_influence" value={control_influence}/>
                </div>

                <div className="form-group">
                    <label
                        htmlFor="current_controls"
                        className="control-label required">
                        Current Controls
                    </label>
                    <textarea className="form-control required"
                              name="current_controls"
                              rows={2}
                              onChange={this.onChange}
                              id="current_controls" value={current_controls}/>
                </div>

                <h6>Risk Rating: </h6>
                <div style={{display: 'flex', flexDirection: 'columns'}}>
                    <div className="form-group" style={{width: '100%'}}>
                        <label
                            htmlFor="severity"
                            className="control-label required">
                            Severity
                        </label>
                        <select
                            value={severity}
                            onChange={this.onChange}
                            className="selectpicker form-control"
                            required="required"
                            id="severity"
                            name="severity">
                            <option value="">Select an option</option>
                            {
                                Object.keys(rates).map(key => <option key={key} value={key}>{rates[key]}</option>)
                            }
                        </select>

                    </div>
                    <div className="form-group" style={{width: '100%'}}>
                        <label
                            htmlFor="likelihood"
                            className="control-label required">
                            Likelihood
                        </label>
                        <select
                            value={likelihood}
                            onChange={this.onChange}
                            className="selectpicker form-control"
                            required="required"
                            id="likelihood"
                            name="likelihood">
                            <option value="">Select an option</option>
                            {
                                Object.keys(rates).map(key => <option key={key} value={key}>{rates[key]}</option>)
                            }
                        </select>

                    </div>
                </div>
            </div>
        )
    }
}





// WEBPACK FOOTER //
// ./src/screens/risks/templates/Environmental.js